import React, {useEffect, useState } from "react";
import "../../../App.css";
import { MdUnarchive } from "react-icons/md";
import {
  Datagrid,
  FunctionField,
  SearchInput,
  useDataProvider,
  useGetList,
  useListContext,
  useRecordContext,
  useGetIdentity,
  useCreate,
} from "react-admin";
import {
  Box,
  ToggleButton,
  ToggleButtonGroup,
  Button as MuiButton,
} from "@mui/material";
import { NumericFormat } from "react-number-format";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  useUpdate,
  useNotify,
  useRefresh,
} from "react-admin";
import { useForm, FormProvider, get } from "react-hook-form";
import FilterListIcon from "@mui/icons-material/FilterList";
import IconButton from "@mui/material/IconButton";
import FilterModel from "./ActionLandloardInbox";
import { TableHead, TableRow, TableCell, Checkbox } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import InfoIcon from "@mui/icons-material/Info";
import { DatagridBody, RecordContextProvider } from "react-admin";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Collapse from "@mui/material/Collapse";
import { useStore } from "react-admin";
import Avatar from "@mui/material/Avatar";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Paper from "@mui/material/Paper";
import { Link } from "react-router-dom";
import { useParams, useNavigate } from "react-router-dom";
import AddressRentEdit from "../AddressRentEdit";
import WarningPrelimNotice from "../WarningPrelimNotice";
import LinearProgress from "@mui/material/LinearProgress";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import DateComponent from "../DateComponent";
import InputField2 from "../../common/InputComponents/InputField2";
import ActionLandloardInbox from "./ActionLandloardInbox";
import ListBaseSubscriber from "./ListBaseSubscriber";
import { GetlandloardinboxListDetails } from "./GetlandloardinboxListDetails";
import { FaRegNoteSticky } from "react-icons/fa6";
import ApplyRental from "./ApplyRental";
import { updateNewTagsForApplicants } from '../../../utils/newTag';
import { getDocUploadStatusDisplayLabel, getSubscriberAtsStatusDisplayLabel } from "../../../utils/atsApplicationStatus";
import {
  canShowScreeningScoreForViewer,
  isInFlightReview,
  isScreeningReportReprocessing,
  shouldHideSystemAssessment,
} from "../../../utils/screeningScore";
import ReportReprocessingIndicator from "../ReportReprocessingIndicator";
export const ToogleFilterInboxType = (props) => {
  const { setFilters, filterValues } = useListContext();
  useEffect(() => {
    if (!filterValues.app_invitation_type) {
      setFilters({ app_invitation_type: "1" }, ["app_invitation_type"]);
    }
  }, []);
  console.log(filterValues, "filterValues");
  return (
    <>
      <ToggleButtonGroup
        sx={{ paddingBottom: 0.5, "& .Mui-selected": { fontWeight: 700 } }}
        size="small"
        value={filterValues.app_invitation_type}
        color="primary"
        exclusive
        onChange={(
          event: React.MouseEvent<HTMLElement>,
          newAlignment: string
        ) => {
          if (newAlignment) {
            setFilters({ app_invitation_type: newAlignment }, [
              "app_invitation_type",
            ]);
          }
        }}
        aria-label="Inbox"
      >
        <ToggleButton value={"1"} aria-label="Application">
          Application
        </ToggleButton>
        <ToggleButton value={"2"} aria-label="Docupload">
          Docupload
        </ToggleButton>
        <ToggleButton value={"3"} aria-label="Docupload">
          Guest Card
        </ToggleButton>
      </ToggleButtonGroup>
    </>
  );
};

export const FilterListInbox = (props) => {
  return (
    <>
      <IconButton
        sx={{
          border: "1px solid",
          borderRadius: " 5px",
          padding: "6px",
          marginLeft: "-10px",
          marginBottom: "4.4px",
        }}
        size="medium"
        aria-label="delete"
      >
        <FilterListIcon />
      </IconButton>
    </>
  );
};

export const filters = [
  <ToogleFilterInboxType source="app_invitation_type" alwaysOn />,
  <SearchInput
    variant="outlined"
    sx={{ backgroundColor: "#fff" }}
    placeholder="Search"
    InputLabelProps={{
      shrink: true,
    }}
    source="q"
    alwaysOn
  />,
];

export default function BasicPopover() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <IconButton
        color="warning"
        style={{ color: "#F9BB04" }}
        size="small"
        aria-label="info"
        aria-describedby={id}
        onClick={handleClick}
      >
        <InfoIcon style={{ fontSize: "14" }} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 2 }}>This is the Rent to Income Ratio.</Typography>
      </Popover>
    </div>
  );
}

const DatagridTableHeaderCell = ({ child }) => {
  const { sort, setSort } = useListContext();
  const sortBy = child?.props?.sortBy || child?.props?.source;
  return (
    <>
      <Box display={"flex"} alignItems={"center"} justifyContent={"start"}>
        <span style={{ padding: "0px 2px" }}>
          {sortBy === sort.field ? (
            sort.order == "ASC" ? (
              <ArrowUpwardIcon style={{ fontSize: 18 }} />
            ) : (
              <ArrowDownwardIcon style={{ fontSize: 18 }} />
            )
          ) : null}
        </span>
        <span
          style={{
            cursor: "pointer",
            fontWeight: "bold",
            color: sortBy === sort.field ? "#000" : "#909090",
          }}
          onClick={() => {
            sortBy && setSort({ field: sortBy, order: "ASC" });
          }}
        >
          {child?.props?.label || child?.props?.source}
        </span>
        {(child?.props?.label || child?.props?.source) == "RI%" && (
          <BasicPopover />
        )}
      </Box>
    </>
  );
};

export const DatagridHeader = (props) => {
  const { children, isRowSelectable, isRowExpandable } = props;
  return (
    <TableHead
      sx={{
        height: 50,
        backgroundColor: "#FFFFFF",
        border: "0.5px solid #E0E0E0",
      }}
    >
      <TableRow>
        {isRowSelectable() && <TableCell></TableCell>}
        {React.Children.map(children, (child) => {
          if (child)
            return (
              <TableCell sortDirection="asc" key={child?.props?.source}>
                <DatagridTableHeaderCell child={child} />
              </TableCell>
            );
        })}
        {isRowExpandable && <TableCell></TableCell>}
      </TableRow>
    </TableHead>
  );
};

const MyDatagridRow = (props) => {
  const {
    record,
    id,
    onToggleItem,
    children,
    selected,
    selectable,
    isRowExpandable,
    isRowSelectable,
    expand,
  } = props;
  const [open, setOpen] = useStore("expandedTable", 0);
  const [tempOpen, setTempOpen] = React.useState(false);

  const timeFormatHandler = (timeData: string) => {
    // get value from fuction call
    const timestamp: any = new Date(timeData);
    // get current time stamp
    const now: any = new Date();
    // calculating a difference
    const diff = now - timestamp;
    // converting a value in to a seconds and seconds to minutes
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    // assign a empty style
    let style = {};
    // code conditional logic
    // if (minutes < 30) {
    // //   formattedTime = "Normal color";
    if (minutes >= 30 && minutes < 150) {
      style = { backgroundColor: "#FFF8E2 !important" };
    } else if (minutes >= 150 && minutes < 360) {
      style = { backgroundColor: "#ffd89d !important" };
    } else if (minutes >= 360) {
      style = { backgroundColor: "#FFEEEE !important" };
    }
    // return a final value
    return style;
  };

  const refresh = useRefresh();
  // const notify = useNotify();
  const [create] = useCreate();

  const onClickHandler = (event, record) => {
    create(
      "updatenewtagapp",
      { data: { ApplicationNumber: record?.id } },
      {
        onSuccess: (data) => {
          refresh();
        },
      }
    );
  };

  return (
    <RecordContextProvider value={record}>
      <TableRow
        className={`${props.className} ${record?.NewTag ? "position-relative" : ""
          }`}
        sx={record?.TimeInQueue ? timeFormatHandler(record?.TimeInQueue) : ""}
      >
        {isRowSelectable() && (
          <TableCell padding="none">
            <Checkbox
              disabled={!selectable}
              checked={selected}
              onClick={(event) => onToggleItem(id, event)}
            />
          </TableCell>
        )}
        {React.Children.map(children, (field) => {
          if (field)
            return (
              <TableCell
                data-label={field?.props?.label || field?.props?.source}
                key={`${id}-${field?.props?.source || field?.props?.label}`}
              >
                {field}
                {field?.props?.source === "App Id" && record?.NewTag ? (
                  <div className="badge-cell position-absolute top-0 start-0">
                    <em className="m-0">New</em>
                  </div>
                ) : (
                  <></>
                )}
              </TableCell>
            );
        })}
        {isRowExpandable() && (
          <TableCell padding="none">
            <IconButton
              aria-label="expand row"
              size="small"
              className="arrow_icon"
              onClick={(event) => {
                setTempOpen(!tempOpen);
                setOpen(open == id ? (open != 0 ? 0 : id) : id);
                if (record?.NewTag && !tempOpen) {
                  onClickHandler(event, record);
                }
              }}
            >
              {open == id ? (
                <KeyboardArrowUpIcon
                  sx={{ color: open == id ? "primary.main" : "#fff" }}
                  className="arrow_up_icon"
                />
              ) : (
                <KeyboardArrowDownIcon className="arrow_down_icon" />
              )}
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      {isRowExpandable() && (
        <TableRow>
          <TableCell padding="none" colSpan={12}>
            <Collapse in={open == id} timeout="auto" unmountOnExit>
              {expand}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </RecordContextProvider>
  );
};

const MyDatagridBody = (props) => (
  <DatagridBody {...props} row={<MyDatagridRow {...props} />} />
);
export const MyDatagrid = (props) => (
  <Datagrid {...props} body={<MyDatagridBody {...props} />} />
);
export const circularBtn = {
  width: 40,
  height: 40,
  borderRadius: 50,
  margin: "0px 40px",
};

export const TopMenu = (props) => {
  return (
    <>
      <div className="app-head-row mr-t30 mb-2">
        <FilterModel />
      </div>
    </>
  );
};



export const GetListLandLoardList = (props) => {
  const { data: identity } = useGetIdentity();
  const { id } = useParams();
  return (
    <>
      <ListBaseSubscriber
        sort={{ field: "id", order: "DESC" }}
        actions={<ActionLandloardInbox />}
        filter={{ subscriberid: id || identity?.subscriberid }}
        exporter={false}
        title={"Inbox"}
      >
        <DatagridTable screeningReport={true} removeSubsriberColumn={true} />
      </ListBaseSubscriber>
    </>
  );
};

export const DatagridTable = (props) => {
  const { id } = useParams();
  const { filterValues } =
    useListContext();
  const { isLoading, isFetching } = useListContext();
  useEffect(() => {
    if (isFetching || isLoading) window.document.title = "Loading";
    else {
      window.document.title = "Docuverus Dashboard";
    }
  }, [isFetching, isLoading]);
  // get user role from  global store
  const { data: identity } = useGetIdentity();
  const userRole =
    useSelector((state: any) => state?.users?.role) || identity?.userrole;

  // logic for button bg and color as per conditions
  const bgStyle = (condition: string) => {
    let style = {};
    switch (condition) {
      case "CompletedConditionallyApproved":
        style = { backgroundColor: "#FFF8E2", color: "#F9BB04" };
        break;
      case "Completed-Unacceptable":
        style = { backgroundColor: "#F8ECE2", color: "#FF4848" };
        break;
      case "Completed-Approved":
        style = { backgroundColor: "#E6FDF0", color: "#46A96F" };
        break;
      case "Invited":
        style = { backgroundColor: "#E9E9E9", color: "#909090" };
        break;
      case "Application In Progress":
        style = { backgroundColor: "#DDF8FF", color: "#1CA2C2" };
        break;
      case "Submitted":
      case "Review Pending":
        style = { backgroundColor: "#B0EFFF", color: "#127790" };
        break;
      // case "Screening":
      case "Completed":
      // case "Completed-Approved":
      case "Verified":
        style = { backgroundColor: "#E6FDF0", color: "#46A96F" };
        break;
      case "Cancelled":
      case "Archived":
      // case "Completed-Unacceptable":
      case "Unverifiable":
        style = { backgroundColor: "#FFEEEE", color: "#FF4848" };
        break;
      case "Completed-Conditionally Approved":
      case "CompletedConditionallyApproved":
      case "Further Documentation Required":
      case "Further Doc Req.":
        style = { backgroundColor: "#FFF8E2", color: "#F9BB04" };
        break;
      default:
        style = {};
    }
    return style;
  };
  const bgStyle1 = (condition: string) => {
    let style = {};
    switch (condition) {
      case "ConditionallyApproved":
      case "Conditionally Approved":
        style = { backgroundColor: "#FFF8E2", color: "#F9BB04" };
        break;
      case "Unacceptable":
        style = { backgroundColor: "#F8ECE2", color: "#FF4848" };
        break;
      case "NoAssessment":
      case "No Assessment":
        style = { backgroundColor: "#fff", color: "#000000" };
        break;
      case "Approved":
        style = { backgroundColor: "#E6FDF0", color: "#46A96F" };
        break;
      default:
        let abc = bgStyle;
        return abc;
    }
    return style;
  };
  const location = useLocation();

  const [create] = useCreate();
  const dataProvider = useDataProvider();

  const onClickHandler = async (event, record) => {
    const applicantData = await dataProvider.getList(
      "get_subscriber_inbox_details",
      {
        filter: {
          ApplicationNumber: record?.id,
          subscriberid: record?.SubscriberID,
        },
        pagination: { page: 0, perPage: 0 },
        sort: { field: "", order: "DESC" },
      }
    );
    await updateNewTagsForApplicants({ create, record, applicantData });
  };
  const notify = useNotify();
  const getDocUploadStatus = (status) => getDocUploadStatusDisplayLabel(status);
  const getAtsStatus = (status) =>
    getSubscriberAtsStatusDisplayLabel(status, userRole);
  const [isLoadingScreeningReport, setIsLoadingReport] = useState(false);

  const onClickScreeningReport = async (event, record) => {
    create(
      "getscreeningreport",
      {
        data: {
          applicantID: record?.ApplicantID,
          subscriberId: record?.SubscriberID,
        },
      },
      {
        onSuccess: (data) => {
          notify(`Screening report opened successfully.`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };
  return (
    <>
      {(isFetching || isLoading) && <LinearProgress />}
      <MyDatagrid
        bulkActionButtons={false}
        isRowExpandable={() => true}
        isRowSelectable={() => false}
        header={<DatagridHeader isRowExpandable={true} />}
        expand={<ExpandTableComponent />}
        sx={{
          "& .RaDatagrid-rowEven": { backgroundColor: "#F9F9F9" },
          "& .RaDatagrid-expandIcon": { color: "#fff" },
          "& .RaDatagrid-expandIconCell": { backgroundColor: "primary.main" },
          "& .RaDatagrid-headerCell": {
            fontWeight: "bold",
            fontSize: 12,
          },
          "& .RaDatagrid-table": {
            fontSize: 12,
          },
          "& .MuiToggleButton-root.Mui-selected": {
            fontWeight: 700,
          },
        }}
      >
        <FunctionField
          source="App Id"
          label="App Id"
          sortByOrder="DESC"
          sortBy="id"
          render={(record) => {
            return (
              <>
                <Box
                  display={"flex"}
                  justifyContent={"start"}
                  flexDirection={"column"}
                >
                  {userRole == "Docuverus Super Admin" ? (
                    (
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/landloard/landLoardInbox/View/${record.SubscriberID || id || identity?.subscriberid
                          }/edit/${record.id}/1${record
                            ? `?data=${(
                              (
                                encodeURIComponent(
                                  JSON.stringify({
                                    ...record,
                                    from: location,
                                  })
                                )
                              )
                            )}`
                            : ""
                          }`}
                        state={{ ...record }}
                        onClick={(event) => onClickHandler(event, record)}
                      >
                        <Typography fontWeight={700} color="primary">
                          {record.id}
                        </Typography>
                      </Link>
                    ) 
                  ) : (filterValues?.app_invitation_type == 1
                  ) ||
                    (filterValues?.app_invitation_type != 1
                    ) ? (

                    (
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/landloard/landLoardInbox/View/${record.SubscriberID || id || identity?.subscriberid
                          }/edit/${record.id}/1${record
                            ? `?data=${encodeURIComponent(
                              (
                                JSON.stringify({ ...record, from: location })
                              )
                            )}`
                            : ""
                          }`}
                        state={{ ...record }}
                        onClick={(event) => onClickHandler(event, record)}
                      >
                        <Typography fontWeight={700} color="primary">
                          {record.id}
                        </Typography>
                      </Link>
                    ) 
                  ) : (
                    <Typography fontWeight={700} color="#303030">
                      {record.id}
                    </Typography>
                  )}
                  <span style={{ fontSize: 10 }} className="d-block">
                    {record.ApplicantCount}{" "}
                    {record.ApplicantCount > 1 ? "Applicants" : "Applicant"}
                  </span>
                </Box>
              </>
            );
          }}
        />
        <FunctionField
          label="Date"
          render={(record) => <DateComponent date={record?.AppDate} />}
          sortBy="AppDate"
        />

        <FunctionField
          label="applicant"
          render={(record) => {
            const applicants = record.ApplicantList?.split(",");
            const maxLength = 20; // Maximum length of the name before truncation
            if (applicants && applicants.length > 0) {
              return applicants.map((item, index) => (
                <span key={index} title={item}>
                  {item.length > maxLength
                    ? `${item.substring(0, maxLength)}...`
                    : item}
                  {index < applicants.length - 1 && ", "}
                </span>
              ));
            } else {
              return ""; // Handle the case when there are no applicants
            }
          }}
        />



        <FunctionField
          source="Rent"
          label="Rent"
          sortBy="Rent"
          render={(record) => {
            return !record.AppliedForRent ? (
              "NA"
            ) : (
              <>
                <NumericFormat
                  thousandSeparator=","
                  displayType="text"
                  thousandsGroupStyle="thousand"
                  decimalScale={2}
                  prefix="$"
                  fixedDecimalScale
                  value={record.AppliedForRent}
                />
                {record?.Subscribertype == "Real Estate" &&
                  record?.ApplicationStatus !== "Invited" ? (
                  <IconButton size="small">
                    <AddressRentEdit record={record} />
                  </IconButton>
                ) : (
                  ""
                )}
              </>
            );
          }}
        />

        <FunctionField
          label={"Status"}
          source="ApplicationStatus"
          render={(record) => {
            const hideSystemAssessment =
              !record.Archived &&
              shouldHideSystemAssessment(record?.ApplicationStatus, userRole);
            const statusStyleKey =
              hideSystemAssessment && isInFlightReview(record?.ApplicationStatus)
                ? "Review Pending"
                : record?.ApplicationStatus;

            return (
              <MuiButton
                sx={{ width: "100%" }}
                variant="contained"
                disableElevation={true}
                style={{
                  ...(hideSystemAssessment
                    ? {}
                    : bgStyle1(
                        record.Archived == true
                          ? "Archived"
                          : record?.ScreeningDetails
                      )),
                  ...bgStyle(
                    record.Archived == true
                      ? "Archived"
                      : statusStyleKey
                  ),
                  textTransform: "capitalize",
                  cursor: "text",
                }}
              >
                {record.Archived == true
                  ? "Archived - " +
                  (record.ApplicationType === "Doc Upload"
                    ? getDocUploadStatus(record?.ApplicationStatus)
                    : getAtsStatus(record?.ApplicationStatus))
                  : record.ApplicationType === "Doc Upload"
                    ? getDocUploadStatus(record?.ApplicationStatus)
                    : getAtsStatus(record?.ApplicationStatus)}
              </MuiButton>
            );
          }}
        />

        {props?.screeningReport && (
          <FunctionField
            source={"Screening / Report"}
            label="Screening / Report"
            render={(record) => {
              return (
                <>
                  {canShowScreeningScoreForViewer(
                    record?.Score,
                    record?.ApplicationStatus,
                    userRole, record?.HasPreservedScreeningReport
                  ) && (
                    <>
                      <Box
                        display={"flex"}
                        flexDirection={"column"}
                        alignItems={"center"}
                      >
                        <Avatar
                          sx={{
                            bgcolor:
                              record.ScreeningDetails ===
                                "ConditionallyApproved" ||
                                record.ScreeningDetails ===
                                "Conditionally Approved"
                                ? "#FFF8E2"
                                : record.ScreeningDetails === "Unacceptable"
                                  ? "#F8ECE2"
                                  : record.ScreeningDetails ===
                                    "NoAssessment" ||
                                    record.ScreeningDetails === "No Assessment"
                                    ? "#fff"
                                    : record.ScreeningDetails === ""
                                      ? "inherit"
                                      : "#E6FDF0",
                            color:
                              record.ScreeningDetails ===
                                "ConditionallyApproved" ||
                                record.ScreeningDetails ===
                                "Conditionally Approved"
                                ? "#F9BB04"
                                : record.ScreeningDetails === "Unacceptable"
                                  ? "#FF4848"
                                  : record.ScreeningDetails == "NoAssessment" ||
                                    record.ScreeningDetails === "No Assessment"
                                    ? "#000000"
                                    : record.ScreeningDetails === ""
                                      ? "inherit"
                                      : "#46A96F",
                            border:
                              record.ScreeningDetails ===
                                "ConditionallyApproved" ||
                                record.ScreeningDetails ===
                                "Conditionally Approved"
                                ? "1px solid #F9BB04"
                                : record.ScreeningDetails === "Unacceptable"
                                  ? "1px solid #FF4848"
                                  : record.ScreeningDetails ===
                                    "NoAssessment" ||
                                    record.ScreeningDetails === "No Assessment"
                                    ? "1px solid #000000"
                                    : record.ScreeningDetails === ""
                                      ? "inherit"
                                      : "1px solid #46A96F",
                          }}
                        >
                          {record?.Score}
                        </Avatar>
                        {
                          <Box display={"flex"} justifyContent={"center"}>
                            <MuiButton
                              disabled={isLoadingScreeningReport}
                              size="small"
                              variant="text"
                              sx={{ minWidth: 0, px: 0.5, "& .MuiButton-endIcon": { ml: "4px", mr: 0 } }}
                              endIcon={isScreeningReportReprocessing(record?.HasPreservedScreeningReport) ? (
                                <ReportReprocessingIndicator active iconOnly />
                              ) : undefined}
                              onClick={(event) =>
                                onClickScreeningReport(event, record)
                              }
                            >
                              View
                            </MuiButton>
                            {record.SecondaryApp && !record.EmailStatus && (
                              <IconButton sx={{ p: "4px" }} size="small">
                                <WarningPrelimNotice
                                  showWithScoreAsIcon={true}
                                />
                              </IconButton>
                            )}
                          </Box>
                        }
                      </Box>
                    </>
                  )}
                </>
              );
            }}
          />
        )}
      </MyDatagrid>
    </>
  );
};

/**
 * this table is display under expended
 * @param props
 * @returns
 */
const ExpandTableComponent = (props) => {
  const record = useRecordContext();
  const { id } = useParams();
  const { filterValues } = useListContext();

  // get user role from  global store
  const { data: identity } = useGetIdentity();
  const userRole =
    useSelector((state: any) => state?.users?.role) || identity?.userrole;

  // get subscriber inbox details call
  const { data: applicantData } = useGetList(
    "get_subscriber_inbox_details",
    {
      filter: {
        ApplicationNumber: record?.id,
        subscriberid: record.SubscriberID,
      },
    }
  );

  const isApplicant = applicantData?.filter((check) => check.Active == false)
  console.log("isApplicant", isApplicant && isApplicant.length)
  const isCheckedApplicant = ((isApplicant && isApplicant.length) == (applicantData && applicantData?.length - 1)) ? false : true
  console.log("isCheckedApplicant", isCheckedApplicant)

  const location = useLocation();
  const [create] = useCreate();

  const onClickHandler = (event, record) => {
    updateNewTagsForApplicants({ create, record, applicantData });
  };
  const refresh = useRefresh();
  const notify = useNotify();
  const [update] = useUpdate();
  const handleUnarchive = async (value) => {
    update(
      "unarchive",
      {
        id: record?.id,
        data: {
          SubscriberID: record?.SubscriberID,
          Reason: value?.Reason,
          IP: "192.168.11.1",
        },
      },
      {
        onError: (error) => {
          const message: any = error;
          notify(`${message.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        },

        onSuccess: (data) => {
          notify(`Your application has been Unarchive`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          refresh();
          handleCloseUnarchieve();
        },
      }
    );
  };
  const validationSchema = Yup.lazy((value) =>
    Yup.object().shape({
      Reason: Yup.string()
        .trim("Reason is required!")
        .required("Reason is required!")
        .max(5000, "maximum 5000 characters is required"),
    })
  );
  const form = useForm({
    defaultValues: {
      Reason: "",
      SubscriberID: record.SubscriberID,
    },
    resolver: yupResolver(validationSchema),
  });
  const [openUnarchieve, setOpenUnarchieve] = React.useState(false);
  const handleOpenunarchive = () => setOpenUnarchieve(true);
  const handleCloseUnarchieve = () => setOpenUnarchieve(false);
  const navigate=useNavigate();

  return (
    <>
      <Dialog
        fullWidth
        open={openUnarchieve}
        onClose={handleCloseUnarchieve}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="error" id="alert-dialog-title">
          <InfoIcon /> Are you sure?
        </DialogTitle>
        <DialogContent>
          <p>
            Are you sure you want to Unarchive the applications? <br />
          </p>

          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(handleUnarchive)}>
              <div className="row">
                <div className="col-12 mr-b10 mt-3">
                  <InputField2
                    label="Reason"
                    source={`Reason`}
                    placeholder="Enter Reason for Archiving Application"
                    labelClass={"lable-title"}
                    additionalInputClass={"cus-control"}
                  />
                </div>
              </div>

              <Box display={"flex"} justifyContent={"end"}>
                <MuiButton
                  startIcon={<MdUnarchive />}
                  sx={{ mx: 1 }}
                  variant="contained"
                  type="submit"
                >
                  <Typography>Unarchive</Typography>
                </MuiButton>
                <MuiButton
                  sx={{ mx: 1 }}
                  onClick={() => {
                    handleCloseUnarchieve();
                  }}
                  variant="outlined"
                  color="secondary"
                  type="button"
                >
                  <Typography>Cancel</Typography>
                </MuiButton>
              </Box>
            </form>
          </FormProvider>
        </DialogContent>
      </Dialog>
      <Paper elevation={0}>
        <Box sx={{ width: "100%", p: 2 }}>
          <GetlandloardinboxListDetails
            appType={
              1
            }
            id={record.id}
            subsciberIdFromRecord={record.SubscriberID}
            secondaryApp={record.SecondaryApp}
            appInvitationType={filterValues?.app_invitation_type}
            applicationType={record?.ApplicationType}
            archiveCancelApp={
              !filterValues.archiveCancelApp &&
              record?.ApplicationStatus !== "Cancelled" &&
              !record.Archived &&
              record?.ApplicationStatus !== "Archived"
            }
          />
          <Box
            sx={{ p: 1, background: "rgba(44, 192, 228, 0.08)" }}
            display={"flex"}
            justifyContent={"space-between"}
          >
            {
              record?.ApplicationStatus != "Cancelled" &&
              (filterValues.archiveCancelApp || record.Archived) && (
                <Box sx={{ py: 1 }} display={"flex"}>
                  <MuiButton
                    variant="text"
                    startIcon={<MdUnarchive fontSize="small" />}
                    sx={{ textTransform: "capitalize" }}
                    onClick={() => {
                      handleOpenunarchive();
                    }}
                  >
                    Unarchive
                  </MuiButton>
                </Box>
              )}
            {!filterValues.archiveCancelApp &&
              record?.ApplicationStatus !== "Cancelled" &&
              !record.Archived && (
                <Box sx={{ py: 1 }} display={"flex"}>
                  <ApplyRental data={record} />
                 {record?.ApplicationStatus !== "Invited" &&
                record?.ApplicationStatus !== "Application In Progress" &&
                record?.ApplicationStatus !== "Submitted" &&
                record?.ApplicationStatus !== "Review Pending" &&
                record?.ApplicationStatus !== "Cancelled" &&
                record?.ApplicationStatus !== "Completed-Approved" &&
                record?.ApplicationStatus !== "Archived" &&
                record?.ApplicationStatus !== "Screening" && <MuiButton onClick={()=>{navigate('/landloard/landLoardInbox/adverseletter',{state:{...record}})}}  startIcon={ <FaRegNoteSticky style={{ fontSize: "14px" }} />} variant='text' sx={{textTransform:"capitalize"}}>View Adverse Letter</MuiButton>}
                </Box>
              )}
            {
              (userRole == "Docuverus Super Admin" ? (
                (
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/landloard/landLoardInbox/View/${record.SubscriberID || id || identity?.subscriberid
                      }/edit/${record.id}/1${record
                        ? `?data=${encodeURIComponent(
                          (JSON.stringify({ ...record, from: location }))
                        )}`
                        : ""
                      }`}
                    state={{ ...record }}
                    onClick={(event) => onClickHandler(event, record)}
                  >
                    <button type="button" className="blue-btn px-4">
                      View Details
                    </button>
                  </Link>
                )
              ) : (filterValues?.app_invitation_type == 1
              ) ||
                (filterValues?.app_invitation_type != 1
                ) ? (
                (
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/landloard/landLoardInbox/View/${record.SubscriberID || id || identity?.subscriberid
                      }/edit/${record.id}/1${record
                        ? `?data=${encodeURIComponent(
                          (JSON.stringify({ ...record, from: location }))
                        )}`
                        : ""
                      }`}
                    state={{ ...record }}
                    onClick={(event) => onClickHandler(event, record)}
                  >
                    <button type="button" className="blue-btn px-4">
                      View Details
                    </button>
                  </Link>
                ) 
              ) : (
                <button
                  type="button"
                  disabled={true}
                  className="blue-btn px-4"
                  style={{ cursor: "not-allowed" }}
                >
                  View Details
                </button>
              ))}
          </Box>
        </Box>
      </Paper>
    </>
  );
};
